<ca-image-loader
  *ngIf="image"
  [background]="background"
  [image]="image"
></ca-image-loader>
<div class="initials" [class.small]="small">{{ initials }}</div>
